import React from 'react';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

interface BodyProps extends TypographyProps {
  size?: 'sm' | 'md' | 'lg';
}

export const H1: React.FC<TypographyProps> = ({ children, className = '', id }) => (
  <h1 id={id} className={`font-display text-4xl font-bold text-gray-900 dark:text-gray-100 ${className}`}>
    {children}
  </h1>
);

export const H2: React.FC<TypographyProps> = ({ children, className = '', id }) => (
  <h2 id={id} className={`font-display text-3xl font-bold text-gray-900 dark:text-gray-100 ${className}`}>
    {children}
  </h2>
);

export const H3: React.FC<TypographyProps> = ({ children, className = '', id }) => (
  <h3 id={id} className={`font-display text-2xl font-semibold text-gray-800 dark:text-gray-200 ${className}`}>
    {children}
  </h3>
);

export const H4: React.FC<TypographyProps> = ({ children, className = '', id }) => (
  <h4 id={id} className={`font-sans text-xl font-semibold text-gray-800 dark:text-gray-200 ${className}`}>
    {children}
  </h4>
);

export const Body: React.FC<BodyProps> = ({ children, className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  return (
    <p className={`font-sans ${sizeClasses[size]} text-gray-600 dark:text-gray-300 ${className}`}>
      {children}
    </p>
  );
};

export const Small: React.FC<TypographyProps> = ({ children, className = '' }) => (
  <p className={`font-sans text-sm text-gray-500 dark:text-gray-400 ${className}`}>
    {children}
  </p>
);

export const Tiny: React.FC<TypographyProps> = ({ children, className = '' }) => (
  <p className={`font-sans text-xs text-gray-400 dark:text-gray-500 ${className}`}>
    {children}
  </p>
);

export const Label: React.FC<TypographyProps & { htmlFor?: string }> = ({ children, className = '', ...props }) => (
  <label className={`block text-sm font-medium text-gray-700 dark:text-gray-300 ${className}`} {...props}>
    {children}
  </label>
);

export const Caption: React.FC<TypographyProps> = ({ children, className = '' }) => (
  <span className={`font-sans text-xs text-gray-500 dark:text-gray-400 ${className}`}>
    {children}
  </span>
);
